import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import user_words from '@/components/user_words'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'user_words',
      component: user_words
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js